<template lang="pug">
  div
    .clients.white
      transition(name="fade")
        router-view
</template>

<script>
import RcBreadcrumb from '@/components/RcBreadcrumb/RcBreadcrumb.vue';

export default {
  components: {
    RcBreadcrumb,
  },
  data() {
    return {
      isDisplayed: true,
      tab: null,
      items: {
        clients: { title: 'comptes', to: { name: 'clients_prestataires_list' } },
        contacts: { title: 'contacts', to: { name: 'clients_contacts_list' } },
      },
    };
  },
  methods: {
    changeSubpath(supPath) {
      this.subPath = supPath;
    },
  },
  computed: {
    showContactName() {
      return this.$route.name === 'client_contact_detail';
    },
    contactName() {
      const contactId = parseInt(this.$route.params.id, 10);
      const contact = this.$store.state.contacts.contacts.find(it => it.id === contactId);
      return contact ? contact.parent_name : null;
    },
  },
};
</script>
